import { useQuery, useMutation, useQueryClient, UseQueryResult } from '@tanstack/react-query';
import {
  getWatchlist,
  captureWatchlist,
  deleteWatchlist,
  WatchlistItem,
} from '../api/watchlistApi';

export const WATCHLIST_KEY = ['watchlist'] as const;

export function watchlistQueryOptions() {
  return {
    queryKey: ['watchlist', 'list'] as const,
    queryFn: getWatchlist,
    staleTime: 60 * 1000,
  };
}

export function useWatchlist(): UseQueryResult<WatchlistItem[], Error> {
  return useQuery(watchlistQueryOptions());
}

export function useCaptureWatchlist() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ symbol }: { symbol: string }) => captureWatchlist(symbol),
    onSuccess: () => qc.invalidateQueries({ queryKey: WATCHLIST_KEY }),
  });
}

export function useDeleteWatchlist() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (itemId: number) => deleteWatchlist(itemId),
    onSuccess: () => qc.invalidateQueries({ queryKey: WATCHLIST_KEY }),
  });
}
